export type ReceiptAllocation = { receiptId: string; amount: string };
export type SupplierPaymentReceipt = { id: string; receiptNumber: string; branchId: string; branchName: string; receiptDate: string; remaining: string };
export const supplierPaymentCents = (value: string): number | null => {
  if (!/^\d{1,12}(?:\.\d{1,2})?$/.test(value)) return null;
  const [whole, fraction = ""] = value.split(".");
  return Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
};
export const supplierPaymentAmount = (cents: number) => `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, "0")}`;
export function validateSupplierAllocations(allocations: ReceiptAllocation[], receipts: SupplierPaymentReceipt[], cap: string) {
  const limit = supplierPaymentCents(cap);
  let total = 0;
  const seen = new Set<string>();
  for (const item of allocations) {
    const amount = supplierPaymentCents(item.amount);
    const remaining = supplierPaymentCents(receipts.find(r => r.id === item.receiptId)?.remaining || "");
    if (seen.has(item.receiptId) || amount == null || amount <= 0 || remaining == null || amount > remaining) return null;
    seen.add(item.receiptId); total += amount;
  }
  return allocations.length && limit != null && total <= limit ? total : null;
}
/** Retain a key for an identical retry; editing a payload starts a new attempt. */
export function supplierPaymentAttempt<T>(previous: { fingerprint: string; key: string } | null, payload: T) {
  const fingerprint = JSON.stringify(payload);
  return previous?.fingerprint === fingerprint ? previous : { fingerprint, key: crypto.randomUUID() };
}
export function cashPhotoDataUrl(blob: Blob): Promise<string> {
  if (blob.size > 3 * 1024 * 1024 || !["image/jpeg", "image/png", "image/webp"].includes(blob.type)) return Promise.reject(new Error("Photo must be JPEG, PNG or WebP and no larger than 3 MB."));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("Could not read the photo."));
    reader.readAsDataURL(blob);
  });
}